;(function () {
  'use strict'

  angular.module('contrast.integrations').constant('VICTOROPS_MESSAGE_TYPES', [
    { value: 'CRITICAL', name: 'Critical' },
    { value: 'WARNING', name: 'Warning' },
    { value: 'ACKNOWLEDGEMENT', name: 'Acknowledgement' },
    { value: 'INFO', name: 'Info' },
    { value: 'RECOVERY', name: 'Recovery' }
  ])
})()
